<script setup lang="ts">
import {ref} from "vue";
import HOSAvatar from "@/components/hOSAvatar.vue";
import Weekdays from "@/components/Weekdays.vue";
import UserWeekAllocationBar from "@/components/pulse/UserWeekAllocationBar.vue";
import PulseCard from "@/components/pulse/PulseCard.vue";
import {CompanyPulseData} from "@/types/DataTypes.ts";

interface Props {
  pulse: CompanyPulseData;
}

const {pulse} = defineProps<Props>();
const expanded = ref(false);

function toggleExpanded() {
  expanded.value = !expanded.value;
}
</script>

<template>
  <div class="border border-surface-200 dark:border-surface-700 rounded-lg overflow-hidden bg-surface">
    <!-- Header (always visible) -->
    <div
      class="flex items-center gap-4 p-4 cursor-pointer hover:bg-surface-50 dark:hover:bg-surface-800 transition-colors"
      @click="toggleExpanded"
    >
      <!-- Expansion icon -->
      <i
        class="pi transition-transform flex-shrink-0"
        :class="expanded ? 'pi-chevron-down' : 'pi-chevron-right'"
      />

      <!-- Person info -->
      <div class="flex items-center gap-2 w-64 flex-shrink-0">
        <HOSAvatar :user="pulse.user"/>
        <span class="font-bold">{{ pulse.user.name }}</span>
      </div>

      <!-- Weekdays overview -->
      <div class="flex items-center gap-2 grow">
        <Weekdays :weekdays="pulse.pulses" :show-time-allocation="false" class="grow" />
      </div>

      <!-- Allocation bar -->
      <div class="flex-shrink-0 w-[40rem]">
        <UserWeekAllocationBar :user-pulses="pulse.pulses" />
      </div>
    </div>

    <!-- Expandable content -->
    <div
      v-if="expanded"
      class="border-t border-surface-200 dark:border-surface-700 p-4 bg-surface"
    >
      <div class="grid grid-cols-5 gap-2">
        <PulseCard
          :pulse="p"
          v-for="p in pulse.pulses"
          :key="p.date"
          class="hover:z-10 hover:drop-shadow-xl"
        />
      </div>
    </div>
  </div>
</template>
